module.exports = __webpack_public_path__ + "static/media/Hubert H. Humphrey - 1968.96df3851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Hubert H. Humphrey - 1968.jpg
// module id = 494
// module chunks = 0